import React, { useState } from 'react';

import CButton from '../components/CButton';
import CModal from '../components/CModal';
import GenericDateRangeSelector from '../components/GenericDateRangeSelector';
import { updateStateAttribute } from '../helpers/helper';

interface Props {
  start_date: boolean;
  end_date: boolean;
  min_date: number;
  max_date: number;
  url: string;
  onDownload: (url: string, startDate?: number, endDate?: number) => Promise<void>;
}

interface State {
  openModal: boolean;
  selectedStartDate: number;
  selectedEndDate: number;
  isDownloading: boolean;
}

export default function CParameterizedDownloadButton(props: Props) {
  const [state, setState] = useState<State>({
    openModal: false,
    selectedStartDate: props.min_date * 1000,
    selectedEndDate: props.max_date * 1000,
    isDownloading: false
  });

  const showDateRangePicker = props.start_date && props.end_date;

  const handleDownload = async () => {
    // Convert from milliseconds to Unix timestamp (seconds)
    const startDate = Math.floor(state.selectedStartDate / 1000);
    const endDate = Math.floor(state.selectedEndDate / 1000);

    try {
      updateStateAttribute<State>({ isDownloading: true }, setState);
      await props.onDownload(props.url, startDate, endDate);
      updateStateAttribute({ isDownloading: false }, setState);
    } catch (e) {
      updateStateAttribute({ isDownloading: false }, setState);
      throw e;
    }

    handleModalClose();
  };

  const handleModalClose = () => {
    // Reset to default dates when modal is closed
    updateStateAttribute<State>(
      {
        openModal: false,
        selectedStartDate: props.min_date * 1000,
        selectedEndDate: props.max_date * 1000,
        isDownloading: false
      },
      setState
    );
  };

  return (
    <>
      <div className={'w-full flex items-center justify-center'}>
        <CButton.Download
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            updateStateAttribute<State>({ openModal: true }, setState);
          }}
        />
      </div>
      {state.openModal && (
        <CModal open={state.openModal} onClose={handleModalClose}>
          {showDateRangePicker && (
            <>
              <GenericDateRangeSelector
                initStartDate={props.min_date ? props.min_date * 1000 : props.min_date}
                initEndDate={props.max_date ? props.max_date * 1000 : props.max_date}
                minDate={props.min_date ? props.min_date * 1000 : props.min_date}
                maxDate={props.max_date ? props.max_date * 1000 : props.max_date}
                onChange={(startUnix, endUnix) => {
                  updateStateAttribute<State>(
                    {
                      selectedStartDate: startUnix,
                      selectedEndDate: endUnix
                    },
                    setState
                  );
                }}
              />
              <div className={'w-full pt-5 flex items-center justify-end'}>
                <CButton.Download
                  onClick={async (e: React.MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    await handleDownload();
                  }}
                  isLoading={state.isDownloading}
                />
              </div>
            </>
          )}
        </CModal>
      )}
    </>
  );
}
